import React from 'react';

export const ContactPage = () => {
  return (
    <div>
      <p>Contact Agent</p>
    </div>
  );
};
